





















































import Vue from "vue";
import ListItem from "@/components/molecules/ListItem.vue";
import SortableList from "@/components/molecules/SortableList.vue";
import ButtonSolid from "@/components/atoms/ButtonSolid.vue";
import { getCharacterlKey } from "@/lib/s3";
import { callApi } from "@/lib/api";
import gql from "graphql-tag";

export default Vue.extend({
  components: { ListItem, SortableList, ButtonSolid },
  props: {
    novelId: String,
    characters: Array as any,
    selectedId: String,
    folder: Object,
    allFolders: Array as object,
    needsDoCustomClickFunction: {
      type: Boolean,
      default: false,
    },
    onClickItem: {
      type: Function,
      default: () => {
        return false;
      },
      required: false,
    }, // アイテムクリック時の処理を外部から指定したい場合に渡す
  },
  data() {
    return {
      isEditing: false,
      items: this.characters,
    };
  },
  watch: {
    items() {
      this.characters = this.items;
    },
    characters() {
      this.items = this.characters;
    },
  },
  methods: {
    saveOrder: async function () {
      const { novelId, items } = this;
      const order = items.map((item) => item.characterId);

      if (this.folder) {
        let folders = this.allFolders;
        folders.forEach((element) => {
          if (element.characterFolderId === this.folder.characterFolderId) {
            element.characterKeys = order;
          }
        });
        const query = `
            mutation UpdateCharacterFolder ($input: UpdateCharacterFolderInput!){
              updateCharacterFolder (input: $input) {
                novelId
                items {
                 characterFolderId
                 name
                 characterKeys
               }
              }
            }
        `;
        await callApi(query, {
          input: {
            novelId,
            items: folders,
          },
        });

        try {
          this.characters.sort((x, y) => {
            return this.folder.characterKeys.indexOf(x.characterId) - this.folder.characterKeys.indexOf(y.characterId);
          });
        } catch (error) {
          console.log(error);
        }
      } else {
        await callApi(
          gql`
            mutation UpdateDisplayOrder($input: UpdateDisplayOrderInput!) {
              updateDisplayOrder(input: $input) {
                order
              }
            }
          `,
          {
            input: {
              novelId,
              kind: "character",
              order,
            },
          }
        );
      }

      this.isEditing = false;
    },
    getCharacterlKey: function (character) {
      return getCharacterlKey(this.novelId, character);
    },
    backToFolderList() {
      this.$emit("backToFolderList");
    },
    setFolder(el) {
      this.$emit("clickSetFolder", {
        character: el.item,
        characterFolder: this.folder,
      });
    },
  },
});
